<div class="custom-menu" [ngClass]="{ show: isOpen }">
  <div class="menu-content">
    <ng-content></ng-content>
  </div>
  @if (showCloseButton) {
    <button class="close-button" (click)="handleCloseMenu()">Close</button>
  }
</div>
